import React from "react";

const CurrencyContext = React.createContext({ currency: "usd", symbol: "$" });

export default CurrencyContext;
